import ErrorModalIcon from "../../Assets/svg/ErrorModalIcon";
import { CloseIcon } from "../../Assets/svg/CloseIcon";

export const ErrorModal = ({ view, onClose, raw = false }) => {
  const renderMessage = view;

  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="icon">
              <ErrorModalIcon />
            </div>
            <button className="btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <p className="para">{renderMessage}</p>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
